declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

// Pushes a custom event into the GTM dataLayer (see GTM-NQG6BNH / GTM-W5HX9MML
// in public/index.html), for interactions GTM's click listener can't catch on
// its own — e.g. a redirect fired from a polling loop rather than a click.
export function trackEvent(event: string, params?: Record<string, unknown>) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (err) {
    console.error("Failed to push GA event", event, err);
  }
}

// A dataLayer push alone isn't enough right before a full-page navigation
// (window.location.* / window.open): not every GTM tag uses a keepalive
// beacon, so the browser can drop it mid-unload. Push the event, then give
// GTM a brief window to dispatch its tags before navigating.
const NAV_TRACKING_DELAY_MS = 150;

export function trackEventBeforeNavigate(event: string, navigate: () => void, params?: Record<string, unknown>) {
  trackEvent(event, params);
  setTimeout(navigate, NAV_TRACKING_DELAY_MS);
}
